import { Box } from '@skooldio/skooldio-ui-components-core';
export default Box;
